import styled from "styled-components";

export const StyledDetailTextWrapper = styled('div')`
    position: relative;
    min-height: 50px;
`;

export const StyledDetailTextLabel = styled('p')`
    margin: 0;
    font-size: 16px;
    line-height: 1.15;
    color: #1f2020;
    font-weight: 700;
    margin-bottom: 12px;
`;

export const StyledDetailText = styled('p')`
    font-size: 1rem;
    color: #1f2020;
    line-height: 1.15;
    margin: 0;
    word-break: break-word;
    max-width: 420px;
`;

